import { Cable } from '../models';
import { useDocument } from './useDocument';

export function useCable(id: string) {
  return useDocument<Cable>('Cables', id);
}
